import { persistDashboardConnector } from 'apiConnector/dashboard/persist';
import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, mergeMap, startWith, take } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import { dashboardLoading, dashboardLoadingFailed } from 'state/quotes/dashboard/dashboard.actions';
import { dashboardLoadedThunk } from 'state/quotes/dashboard/dashboard.thunks';
import type { EpicWithThunk } from 'state/state.common';

export function loadActiveQuotes(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const dashboardVisible$ = actions$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/static' || path === '/dynamic'),
    );

    return dashboardVisible$.pipe(
      take(1),
      mergeMap(() => {
        return persistDashboardConnector(httpClient)
          .load()
          .pipe(
            mergeMap(activeQuotes =>
              of(dashboardLoadedThunk(activeQuotes.quoteIds, activeQuotes.metadata, activeQuotes.data)),
            ),
            startWith(dashboardLoading()),
            catchError(err =>
              of(
                dashboardLoadingFailed(apiErrorHelper.toApiErrorMessage(err)),
                showNotificationThunk({
                  level: 'danger',
                  title: { id: 'dashboard.errors.title' },
                  content: [{ id: 'dashboard.errors.loadingFailed' }],
                }),
              ),
            ),
          );
      }),
    );
  };
}
